import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { Helper } from '../common/helpers/Helper';

export class YoutubeLayout extends Component {

  constructor(props) {
    super(props)
    // Youtube --
    this.videoUrls = [
      // {link:'https://youtu.be/EvyLfVJkSbA'},
      {link:'https://youtu.be/VcriHeBkUtc'},
      // {link:'https://youtu.be/7PUDR_w9XG0'},
      // {link:'https://youtu.be/R2ddp-gv0Qc'}
    ]
    this.YT_PREFIX = 'YT-'
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    if (firstScriptTag) {
      setTimeout(this.onYouTubeIframeAPIReady, 500)
    }
  }
  onYouTubeIframeAPIReady = () => {
    if (!window.YT) return
    const that = this
    window.YT.ready(function () {
      that.videoUrls.map((x, index) => {

        const videoId = Helper.getVideoId(x.link)

        new window.YT.Player(that.YT_PREFIX + index, {
          width: '100%',
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            controls: 0,
            disablekb: 0,
            enablejsapi: 1,
            fs: 1,
            // eslint-disable-next-line camelcase
            iv_load_policy: 1,
            loop: 0,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            mute: 1
          },
          controlBar: {
            // pictureInPictureToggle: false
          }
        })
      })
    })
  }
  render() {
    return (
      <div className={css(Styles.contentHolderFull)}>
        {
          this.videoUrls.map((x, index) => (
            <div key={this.YT_PREFIX + index} id={this.YT_PREFIX + index} className={css(Styles.video,this.props.videoHeight)} ></div>
          ))
        }
      </div>
    )
  }
}
const Styles = StyleSheet.create({
  contentHolderFull: {
    maxHeight: '100vh',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    background: '#000'
  },
  videoBody: {
    backgroundColor: '#000'
  },
  video: {
    width: '100%',
    height: '100vh',
    objectFit: 'contain'
  }
})



// WEBPACK FOOTER //
// ./src/screens/YoutubeLayout.js